import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  activateChangeSensorStateMode,
  saveActionDeviceStateInfo,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectBrightnessActionStateSelected
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/MezzoLightsActions/SelectBrightnessActionStateSelected/SelectBrightnessActionStateSelected'
import SelectBrightnessActionStateSelectedIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/MezzoLightsActions/SelectBrightnessActionStateSelected/SelectBrightnessActionStateSelected'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectBrightnessActionStateSelectedIOS) : withStyles(SelectBrightnessActionStateSelected)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    stateDescription,
    actionDeviceNumber,
    durationDescription,
    durationValueAfter,
    duration: actionDuration,
    delay: actionDelay,
    actionType,
  } = state.scenes.currentSceneCreating.currentAction
  const { isEditActionMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    stateDescription,
    isEditActionMode,
    actionDeviceNumber,
    durationDescription,
    durationValueAfter,
    actionDuration,
    actionDelay,
    actionType,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionDeviceStateInfo,
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  activateChangeSensorStateMode,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectBrightnessActionStateSelectedEnhanced = enhance

export default withRouter(SelectBrightnessActionStateSelectedEnhanced)
